module.exports = __webpack_public_path__ + "static/media/quick-entry.22b5841a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/quick-entry.png
// module id = 468
// module chunks = 0